<template>
    <div>
        <div v-if="!open && role == 6" class="row">
            <div class="col">
                <button class="btn btn-danger btn-micro" @click="janelaEstorno()">Estornar</button>
            </div>
        </div>
        <vuestic-modal ref="forceEstorno" :noButtons="true" >
            <div class="row">
                <div class="col-8 offset-2">
                    <h3>Estorno de fatura</h3>
                    <div class="d-flex flex-column">
                        <label for="observacao">Razão para estorno</label>
                        <input style="display: block" name="observacao" id="observacao" v-model="observacao"/>
                    </div>
                    <div>
                        <input type="checkbox" name="forcar" id="forcar" v-model="force" class="mr-2">
                        <label for="forcar">Forçar estorno</label>
                    </div>
                    <div class="d-flex" >
                        <button class="btn btn-primary btn-micro mx-1" @click="realizarEstorno()" :disabled="disabled">SIM</button>
                        <button class="btn btn-secondary btn-micro mx-1" @click="fecharModal()">NÃO</button>
                    </div>
                </div>
            </div>
        </vuestic-modal>
    </div>
</template>
<script>
import urlApiV2 from '@/router/urlApiV2'
export default {
    props: {
        fatura: {
            type: Number,
            required: true,
        },
        schema: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            open: false,
            observacao: '',
            force: false,
            disabled: false,
            role: localStorage.id_role
        }
    },
    methods: {
        janelaEstorno() {
            this.$refs.forceEstorno.open();
        },
        realizarEstorno() {
            this.disabled = true;
            this.$toasted.info('Verificando aulas do aluno...', {
                position: 'top-right',
                icon: 'fa-time',
            })
            this.$http.post(urlApiV2 + '/faturamento/estorno', { fatura: this.fatura, schema: this.schema, observacao: this.observacao, force: this.force })
            .then(
                (response) => {
                    this.$toasted.success(response.data.mensagem, {
                        position: 'top-right',
                        icon: 'fa-check',
                    })
                    this.fecharModal();
                    this.$emit('estornado');
                },
                (error) => {
                    switch(error.status) {
                        case 400:
                            this.$toasted.error(error.data.mensagem, {
                                position: 'top-right',
                                icon: 'fa-close',
                            });
                            break;
                    }
                }
            ).then(() => {
                this.disabled = false;
            })
        },
        fecharModal() {
            this.$refs.forceEstorno.close()
        }
    }
}
</script>
